module.exports = __webpack_public_path__ + "cherry-blossoms.png?3c6a09fb133536539f3665876a788b7a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad windows/cherry-blossoms.png
// module id = 31
// module chunks = 0